import React, { useState, useCallback, useContext } from "react";
import { AuthenticationContext } from "../AuthenticationContextProvider";
import { ConfigContext } from "../ConfigContextProvider";

const ItemLibrary = (props) => {
  const { APPID } = useContext(ConfigContext);
  const { userOptions } = useContext(AuthenticationContext);
  const { DOWNLOAD_URL } = useContext(ConfigContext);

  const downloadDetailHandler = useCallback((link, label, action) => {
    if (userOptions && Number(userOptions.login)) {
      let filename = link;
      let pos = String(link).lastIndexOf(".");
      let ext = link.substr(pos + 1);
      let filenameNoPath = link.substr(String(link).lastIndexOf("/") + 1);

      if (window.mainunity && window.mainunity === "in") {
        filename = link.substring(0, pos);
        filename += "_in." + ext;
      }
      window.location.href = DOWNLOAD_URL + "?file=" + filename;
      window.sendToGTM({
        event: "file_download",
        category: "3dlibrary",
        action: action,
        label: label,
        file_name: filenameNoPath,
        file_extension: ext,
      });
    } else {
      const event = new CustomEvent("login", {
        detail: { APPID: APPID, fMode: "LOGIN" ,namespace:"modalAuth"},
      });
      document.dispatchEvent(event);
    }
  });

  const getRenderLink = useCallback((download, i, name) => {
    const isLoggedIn = userOptions && Number(userOptions.login);
    
    return (
      <button
        className="itemLibrary__link"
        key={"download_disable" + i}
        onClick={(e) => {
          e.preventDefault();
          downloadDetailHandler(download.link, download.label, name);
        }}
        aria-label={isLoggedIn ? 
          `${!download.label.toLowerCase().includes('download') ? 'Download ' : ''}${download.label} ${name}` : 
          `${!download.label.toLowerCase().includes('download') ? 'Download ' : ''}${download.label} ${name} - opens login dialog`}
        aria-haspopup={!isLoggedIn ? "dialog" : undefined}
        aria-describedby={!isLoggedIn ? "login-required-description" : undefined}
        type="button"
      >
      <span className="icon__download" aria-hidden="true">
        <svg width="13.981" height="18.286" viewBox="0 0 13.981 18.286">
          <g transform="translate(0 2)">
            <rect
              width="13.981"
              height="2.33"
              transform="translate(0 13.957)"
            />
            <path
              d="M21.847-61.3,20.2-62.944l-4.257,4.257v-9.869H13.765v9.869L9.508-62.944,7.866-61.3l6.991,6.991Z"
              transform="translate(-7.865 66.556)"
            />
          </g>
        </svg>
      </span>
      <span className="itemLibrary__linkLabel">{download.label}</span>
    </button>
    );
  });

  //href={download.link}
  //onClick={() => { downloadDetailHandler(download.link)}}

  const { item } = props;
  
  return (
    <>
      <li className="itemLibrary">
        <div className="itemLibrary__imgWrappper">
          <div className="itemLibrary__btnDetail">
            <img alt="" src={item.img}></img>
          </div>
        </div>

        <div className={`itemLibrary__textWrapper  ${item.downloadGroup && item.downloadGroup.length >0 ? "itemLibrary__textWrapper--download" : ""}   `}>
          <p className="itemLibrary__name">
            <strong>{item.name}</strong>
            {item.description && item.downloadGroup && item.downloadGroup.length >0 &&(
            <span className="itemLibrary__description"> {item.description}</span>
          )}
          </p>
          {item.description && !item.downloadGroup &&(
            <p className="itemLibrary__description">{item.description}</p>
          )}
        </div>

        {item.downloadGroup &&
          item.downloadGroup.length > 0 &&
          item.downloadGroup.map((downloadGroup, i) => (
            <>
              {downloadGroup.name && (
                <p className="itemLibrary__nameGroup">
                <strong>{downloadGroup.name}</strong>
              </p>

              )}
              <div className="itemLibrary__linkWrapper">
                {downloadGroup.download &&
                  downloadGroup.download.length > 0 &&
                  downloadGroup.download.map((download, i) =>
                    getRenderLink(download, i, item.name)
                  )}
              </div>
            </>
        ))}

        <div className="itemLibrary__linkWrapper">
          {item.download &&
            item.download.length > 0 &&
            item.download.map((download, i) =>
              getRenderLink(download, i, item.name)
            )}
        </div>
      </li>
    </>
  );
};

export default ItemLibrary;
